/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Redaction_DescInputs */



/**
* | output |
* | --- |
* | "Content matching these patterns was redacted before the message reached the model. The redacted text itself is never stored in this log." |
*
* @param {Audit_Details_Redaction_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_redaction_desc = /** @type {((inputs?: Audit_Details_Redaction_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Redaction_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhalte, die diesen Mustern entsprechen, wurden redigiert, bevor die Nachricht das Modell erreichte. Der redigierte Text selbst wird in diesem Protokoll nie gespeichert.")
	return /** @type {LocalizedString} */ ("Content matching these patterns was redacted before the message reached the model. The redacted text itself is never stored in this log.")
});